import { ConfirmationModal } from "@design-system/Modal/ConfirmationModal";

interface Props {
    show: boolean;
    onConfirm: () => Promise<void>;
    onClose: () => void;
}

export const RefinalizeMappingConfirmationModal = ({
    show,
    onConfirm,
    onClose,
}: Props) => (
    <ConfirmationModal
        show={show}
        onHide={onClose}
        onReject={onClose}
        onConfirm={onConfirm}
        title="Update accounts mapping"
        question={
            "Journal entries migrated from your previous accounting system " +
            "will be regenerated with the new mapping, and any changes you " +
            "made to them will be lost. Opening balances created by the " +
            "migration will be rebuilt as well."
        }
        yes="Update mapping"
        no="Cancel"
    />
);
